"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _transparentize = _interopRequireDefault(require("polished/lib/color/transparentize"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'white';

  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing,
      boxShadow = _useTheme.boxShadow,
      colors = _useTheme.colors;

  return (0, _react.useMemo)(function () {
    return {
      root: {
        backgroundColor: colors[color],
        padding: spacing(2),
        border: 'none',
        borderRadius: spacing(3),
        boxShadow: boxShadow('black', 1),
        transition: 'box-shadow 0.2s ease-in-out'
      },
      dense: {
        padding: spacing(0.5, 2)
      },
      outlined: {
        backgroundColor: (0, _transparentize["default"])(0.9)(colors[color]),
        border: "1px solid ".concat(colors[color]),
        boxShadow: 'none'
      },
      clickable: {
        userSelect: 'none',
        cursor: 'pointer',
        WebkitTapHighlightColor: 'transparent',
        ':focus, :hover': {
          outline: 'none',
          boxShadow: boxShadow('black', 3)
        },
        ':active': {
          boxShadow: boxShadow('black', 4)
        }
      }
    };
  }, [spacing, boxShadow, colors, color]);
};

__signature__(useStyles, "useTheme{{ spacing, boxShadow, colors }}\nuseMemo{}", function () {
  return [_useTheme2["default"]];
});

var Chip = function Chip(props, ref) {
  var onClick = props.onClick,
      color = props.color,
      dense = props.dense,
      outlined = props.outlined,
      other = (0, _objectWithoutProperties2["default"])(props, ["onClick", "color", "dense", "outlined"]);
  var classes = useStyles(color);
  return (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
    as: onClick ? 'button' : 'div',
    ref: ref,
    css: /*#__PURE__*/(0, _css2["default"])([classes.root, dense && classes.dense, outlined && classes.outlined, onClick && classes.clickable], ";label:Chip;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")),
    onClick: onClick,
    alignItems: "center"
  }, other));
};

__signature__(Chip, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = (0, _react.forwardRef)(Chip);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Chip/index.tsx");
  reactHotLoader.register(Chip, "Chip", "/builds/bA1zbJom/0/gojob/ui-bits/src/Chip/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Chip/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();